import React, { useState } from "react";
import './SearchableTree.css';
import { Input, Tree, Select } from "antd";
import { Box, Card, CardHeader, Divider } from "@mui/material";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import { CloseOutlined } from "@ant-design/icons";

const { Option } = Select;

const SearchableTree = ({ treeData, onSelect, title, theme = "light" }) => {
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [autoExpandParent, setAutoExpandParent] = useState(true);
  const isDark = theme === "dark";
  const treeColors = {
    panelBg: isDark ? "#1E1E1E" : "#FFFFFF",
    text: isDark ? "#FFFFFF" : "#3C3C3C",
    border: isDark ? "#3B4248" : "#E5E9E8",
  };

  const onExpand = (expandedKeysValue) => {
    setExpandedKeys(expandedKeysValue);
    setAutoExpandParent(false);
  };

  const onSearch = (e) => {
    const { value } = e.target;
    setSearchText(value);

    const expandedKeys = treeData
      .map((item) => {
        if (item.title.toLowerCase().includes(value.toLowerCase())) {
          return getAllParentKeys(treeData, item.key);
        }
        return null;
      })
      .flat()
      .filter((key, index, self) => key && self.indexOf(key) === index);

    setExpandedKeys(expandedKeys);
    setAutoExpandParent(true);
  };

  const getAllParentKeys = (nodes, key, parentKeys = []) => {
    for (let node of nodes) {
      if (node.key === key) {
        return parentKeys;
      }
      if (node.children) {
        const found = getAllParentKeys(node.children, key, [...parentKeys, node.key]);
        if (found) return found;
      }
    }
    return [];
  };

  const renderTreeNodes = (nodes) =>
    nodes.map((node) => ({
      ...node,
      title: (
        <span style={{ display: "flex", alignItems: "center", color: treeColors.text }}>
          {node.title}
        </span>
      ),
      children: node.children ? renderTreeNodes(node.children) : undefined,
    }));

  // Only allow selection of leaf nodes
  const handleSelect = (selectedKeys, info) => {
    const node = info.node;
    if (!node.children || node.children.length === 0) {
      setSelectedKeys(selectedKeys);
      onSelect(selectedKeys, info);
    }
  };

  const handleDropdownChange = (value) => {
    setExpandedKeys([value]);
    setAutoExpandParent(false);
  };

  return (
    <Card
      sx={{
        width: "100%",
        height: "auto",
        borderRadius: "0px",
        zIndex: "9999",
        overflow: "scroll",
        backgroundColor: treeColors.panelBg,
        border: `1px solid ${treeColors.border}`,
        boxShadow: "none",
      }}
    >
      {/* <CardHeader
        sx={{ px: 2, py: 1 }}
        subheader={
          <Box>
            <Select
              placeholder="Select Node to Expand"
              style={{ width: "100%", marginTop: "10px" }}
              onChange={handleDropdownChange}
              dropdownStyle={{ zIndex: 20000 }}
            >
              {treeData.map((item) => (
                <Option key={item.key} value={item.key}>
                  {item.title}
                </Option>
              ))}
            </Select>
          </Box>
        }
      /> */}
      {/* <Divider /> */}
      <Box width="100%" height="83%" overflow="auto" sx={{ backgroundColor: treeColors.panelBg }}>
        <Tree
          style={{ background: "transparent", color: treeColors.text }}
          checkable={false}
          onExpand={onExpand}
          expandedKeys={expandedKeys}
          autoExpandParent={autoExpandParent}
          showIcon
          switcherIcon={({ expanded }) => (
            <ExpandMoreOutlinedIcon
              sx={{
                height: "20px",
                width: "20px",
                color: treeColors.text,
                transform: expanded ? "rotate(0deg)" : "rotate(-90deg)",
                transition: "transform 0.3s ease",
                overflow:"scroll"
              }}
            />
          )}
          onSelect={handleSelect}
          selectedKeys={selectedKeys}
          treeData={renderTreeNodes(treeData)}
        />
      </Box>
    </Card>
  );
};

export default SearchableTree;